import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
  component: () => import('@/pages/job-careers/page-job-grid.vue'),

  },
  {
    path: "/auth-login",
    name: "auth-login",
    alias: ["/login","/signin","/sign-in"],
    component: () => import('@/pages/auth-pages/auth-login.vue'),
  },
  {
    path: "/auth-signup",
    name: "auth-signup",
    alias: ["/signup","/register","/sign-up"],
    component: () => import('@/pages/auth-pages/auth-signup.vue'),
  },
  {
    path: "/auth-re-password",
    name: "auth-re-password",
    component: () => import('@/pages/auth-pages/auth-re-password.vue'),
  },
  {
    path: "/auth-lock-screen",
    name: "auth-lock-screen",
    component: () => import('@/pages/auth-pages/auth-lock-screen.vue'),
  },
  {
    path: "/contact-one",
    name: "contact-one",
    component: () => import('@/pages/contact-one.vue'),
  },
  {
    path: "/page-comingsoon",
    name: "page-comingsoon",
    component: () => import('@/pages/special-pages/page-comingsoon.vue'),
  },
  {
    path: "/page-maintenance",
    name: "page-maintenance",
    component: () => import('@/pages/special-pages/page-maintenance.vue'),
  },
  {
    path: "/page-thankyou",
    name: "page-thankyou",
    component: () => import('@/pages/special-pages/page-thankyou.vue'),
  },
  {
    path: "/page-aboutus",
    name: "page-aboutus",
    component: () => import('@/pages/company/page-aboutus.vue'),
  },
  {
    path: "/page-services",
    name: "page-services",
    component: () => import('@/pages/company/page-services.vue'),
  },
  {
    path: "/page-team",
    name: "page-team",
    component: () => import('@/pages/company/page-team.vue'),
  },
  {
    path: "/page-pricing",
    name: "page-pricing",
    component: () => import('@/pages/company/page-pricing.vue'),
  },
  {
    path: "/page-testimonial",
    name: "page-testimonial",
    component: () => import('@/pages/company/page-testimonial.vue'),
  },
  {
    path: "/user-profile",
    name: "user-profile",
    component: () => import('@/pages/account/user-profile.vue'),
  },
  {
    path: "/admin-dashboard",
    name: "admin-dashboard",
    component: () => import('@/pages/account/admin-dashboard.vue'),
  },
  {
    path: "/user-billing",
    name: "user-billing",
    component: () => import('@/pages/account/user-billing.vue'),
  },
  {
    path: "/user-payment",
    name: "user-payment",
    component: () => import('@/pages/account/user-payment.vue'),
  },
  {
    path: "/user-job-applications",
    name: "user-job-applications",
    component: () => import('@/pages/account/user-job-applications.vue'),
  },
  {
    path: "/user-invoice",
    name: "user-invoice",
    component: () => import('@/pages/account/user-invoice.vue'),
  },
  {
    path: "/user-setting",
    name: "user-setting",
    component: () => import('@/pages/account/user-setting.vue'),
  },
  {
    path: "/page-job-grid",
    name: "page-job-grid",
    component: () => import('@/pages/job-careers/page-job-grid.vue'),
  },
  {
    path: "/embed/job-grid",
    name: "page-job-grid-embed",
    component: () => import('@/pages/job-careers/page-job-grid-embed.vue'),
  },
  {
    path: "/page-job-exam/:id",
    name: "page-job-exam",
    component: () => import('@/pages/job-careers/page-job-exam.vue'),
  },
  {
    path: "/page-job-detail",
    name: "page-job-details",
    component: () => import('@/pages/job-careers/page-job-detail.vue'),
  },
  {
    path: "/admin-cv-listing",
    name: "admin-cv-listing",
    component: () => import('@/pages/account/admin-cv-listing.vue'),
  },
  {
    path: "/admin-cv-match",
    name: "admin-cv-match",
    component: () => import('@/pages/account/admin-job-listing.vue'),
  },
  {
    path: "/admin-job-listing",
    name: "admin-job-listing",
    component: () => import('@/pages/account/admin-job-listing.vue'),
  },
  {
    path: "/admin-job-card-listing",
    name: "admin-job-card-listing",
    component: () => import('@/pages/account/admin-job-card-listing.vue'),
  },
  {
    path: "/admin-company-listing",
    name: "admin-company-listing",
    component: () => import('@/pages/account/admin-company-listing.vue'),
  },
  {
    path: "/admin-company-update/:id",
    name: "admin-company-update",
    component: () => import('@/pages/account/admin-company-create.vue'),
  },
  {
    path: "/admin-company-create",
    name: "admin-company-create",
    component: () => import('@/pages/account/admin-company-create.vue'),
  },
  {
    path: "/admin-user-listing",
    name: "admin-user-listing",
    component: () => import('@/pages/account/admin-user-listing.vue'),
  },
  {
    path: "/admin-settings",
    name: "admin-settings",
    component: () => import('@/pages/account/admin-settings.vue'),
  },
  {
    path: "/page-job-detail/:id",
    name: "page-job-detail",
    component: () => import('@/pages/job-careers/page-job-detail.vue'),
  },
  {
    path: "/page-job-apply/:id",
    name: "page-job-apply",
    component: () => import('@/pages/job-careers/page-job-apply.vue'),
  },
  {
    path: "/page-job-post",
    name: "page-job-post",
    component: () => import('@/pages/job-careers/page-job-post.vue'),
  },
  {
    path: "/page-job-edit/:id",
    name: "page-job-edit",
    component: () => import('@/pages/job-careers/page-job-post.vue'),
  },
  {
    path: "/page-job-career",
    name: "page-job-career",
    component: () => import('@/pages/job-careers/page-job-career.vue'),
  },
  {
    path: "/page-job-candidates",
    name: "page-job-candidates",
    component: () => import('@/pages/job-careers/page-job-candidates.vue'),
  },
  {
    path: "/page-job-candidate-detail",
    name: "page-job-candidate-detail",
    component: () => import('@/pages/job-careers/page-job-candidate-detail.vue'),
  },
  {
    path: "/page-job-companies",
    name: "page-job-companies",
    component: () => import('@/pages/job-careers/page-job-companies.vue'),
  },
  {
    path: "/page-job-company-detail",
    name: "page-job-company-detail",
    component: () => import('@/pages/job-careers/page-job-company-detail.vue'),
  },
  {
    path: "/helpcenter",
    name: "helpcenter",
    component: () => import('@/pages/helpcenter/helpcenter.vue'),
  },
  {
    path: "/helpcenter-faqs",
    name: "helpcenter-faqs",
    component: () => import('@/pages/helpcenter/helpcenter-faqs.vue'),
  },
  {
    path: "/helpcenter-guides",
    name: "helpcenter-guides",
    component: () => import('@/pages/helpcenter/helpcenter-guides.vue'),
  },
  {
    path: "/helpcenter-support",
    name: "helpcenter-support",
    component: () => import('@/pages/helpcenter/helpcenter-support.vue'),
  },
  {
    path: "/email-confirmation",
    name: "email-confirmation",
    component: () => import('@/pages/email-template/email-confirmation.vue'),
  },
  {
    path: "/email-password-reset",
    name: "email-password-reset",
    component: () => import('@/pages/email-template/email-password-reset.vue'),
  },
  {
    path: "/email-alert",
    name: "email-alert",
    component: () => import('@/pages/email-template/email-alert.vue'),
  },
  {
    path: "/email-invoice",
    name: "email-invoice",
    component: () => import('@/pages/email-template/email-invoice.vue'),
  },
  {
    path: "/auth-signup-success",
    name: "auth-signup-success",
    component: () => import('@/pages/auth-pages/auth-signup-success.vue'),
  },
  {
    path: "/page-terms",
    name: "page-terms",
    component: () => import('@/pages/utility/page-terms.vue'),
  },
  {
    path: "/page-privacy",
    name: "page-privacy",
    component: () => import('@/pages/utility/page-privacy.vue'),
  },
  {
    path: "/contact-detail",
    name: "contact-detail",
    component: () => import('@/pages/contact/contact-detail.vue'),
  },
  {
    path: "/:catchAll(.*)",
    name: "Error",
    component: () => import('@/pages/special-pages/page-error.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;